const collator = new Intl.Collator(['uk', 'ru', 'en'], { sensitivity: 'base' })
const byNameAsc = (a, b) => collator.compare(a?.name || '', b?.name || '')
const getSortBucket = (node) => Number.isFinite(node?.sortBucket) ? node.sortBucket : 0

const byOrdnungThenName = (a, b) => {
    const bucketDiff = getSortBucket(a) - getSortBucket(b)
    if (bucketDiff !== 0) return bucketDiff

    const ao = a?.ordnung
    const bo = b?.ordnung
    const aHas = typeof ao === 'number'
    const bHas = typeof bo === 'number'

    if (aHas && bHas && ao !== bo) return ao - bo
    if (aHas && !bHas) return -1
    if (!aHas && bHas) return 1
    return byNameAsc(a, b)
}

function collectExpandedIds(node, acc) {
    if (!node) return
    for (const child of node.children || []) {
        if (child.expanded) acc.add(child.id)
        collectExpandedIds(child, acc)
    }
}

function sortDeep(arr) {
    if (!Array.isArray(arr)) return
    arr.sort(byOrdnungThenName)
    for (const n of arr) {
        if (n.children?.length) sortDeep(n.children)
    }
}

export function buildHierarchy(nodes, activeRootRef, options = {}) {
    const { oneLevelMode = false, showDeletedNodes = false } = options || {}

    if (!Array.isArray(nodes)) {
        activeRootRef.value.children = []
        return
    }

    const expandedBefore = new Set()
    collectExpandedIds(activeRootRef.value, expandedBefore)

    const list = nodes.map(n => ({
        ...n,
        expanded: expandedBefore.has(n.id) || !!n.expanded,
        children: []
    }))

    if (oneLevelMode) {
        const roots = list.filter(n => showDeletedNodes || !n.hide)
        roots.sort(byOrdnungThenName)
        activeRootRef.value.children = roots
        return
    }

    const byId = new Map(list.map(n => [n.id, n]))
    list.forEach(n => (n.children = []))

    for (const n of list) {
        if (n.parent_id && byId.has(n.parent_id)) {
            byId.get(n.parent_id).children.push(n)
        }
    }

    const roots = list.filter(n => !n.parent_id || !byId.has(n.parent_id))

    sortDeep(roots)

    activeRootRef.value.children = roots
}

export function isDescendant(candidateId, ancestorId, nodesArray) {
    if (!candidateId || !ancestorId || candidateId === ancestorId) return false
    const byId = new Map(nodesArray.map(n => [n.id, n]))
    let current = byId.get(candidateId)
    while (current && current.parent_id) {
        if (current.parent_id === ancestorId) return true
        current = byId.get(current.parent_id)
    }
    return false
}

export function flatten(nodes, acc = []) {
    for (const n of nodes || []) {
        acc.push(n)
        if (n.children?.length) flatten(n.children, acc)
    }
    return acc
}
/*
export function prepareNodes(nodesData, objId) {  
    if(!nodesData) return []   
    let ret =  nodesData.map(n => ({
        parent_id: n.parent_id === 0 || n.id===1 ? null : n.parent_id,
        id: n.id,
        name: n.name,
        ordnung: n.ordnung ?? null,
        fixed: n.fixed ?? false,
        expanded: false,
        obj_id:n.obj_id || null,
        //children: [],
        hide:n.hide
    })).filter(n => objId?n.obj_id==objId:true && n.hide==false)  
    return ret   
}
*/

export function prepareNodes(nodesData) {  
    if(!nodesData) return []   
    let ret =  nodesData.map(n => ({
        parent_id: n.parent_id === 0 || n.id===1 ? null : n.parent_id,
        id: n.id,
        name: n.name,
        ordnung: n.ordnung ?? null,
        fixed: n.fixed ?? false,
        expanded: false,
        config_id:n.config_id ?? null,
        hide:n.hide,
        root_obj_id: n.root_obj_id || n.mtime_id || null 
    }))
    return ret   
}

  